import { Image, Pill } from "@src/appV2/redesign/system/ui-components";

import googleMapsLogo from "./googleMapsLogo.png";

export function GoogleReviewBadge() {
  return (
    <Pill
      size="small"
      variant="filled"
      label={<Image src={googleMapsLogo} alt="Google Maps" height={14} />}
      backgroundColor={(theme) => theme.palette.text.tertiary}
      sx={{ width: "fit-content", "& > *:first-child": { display: "flex" } }}
    />
  );
}
